export const EXPANDABLE_TRIANGLE_CONFIG = {
    sideWidth: 10,
    padding: 5,
    qRadius: 22,
    qPadding: 1
};
